import Glide from "@glidejs/glide";
import $ from "jquery";

$(() => {
  const carousels = $(".testimonial-carousel");
  if (carousels.length) {
    carousels.each((i, carouselEl) => {
      const carousel = $(carouselEl);
      const setArrowPosition = () => {
        let position;
        const windowWidth = $(window).outerWidth();
        const glideEl = carousel.find(".glide");
        const arrowHeight = carousel.find(".glide__arrows").outerHeight();

        if (windowWidth < 1024) {
          const activeSlideImageEl = carousel.find(
            ".glide__slide--active .testimonial-image"
          );
          position =
            activeSlideImageEl.offset().top -
            glideEl.offset().top -
            arrowHeight / 2;
        }
        if (windowWidth >= 1024) {
          const outerEl = carousel.find(".outer");
          const offsetTop = glideEl.offset().top - outerEl.offset().top;
          const offsetBottom =
            outerEl.offset().top +
            outerEl.outerHeight() -
            (glideEl.offset().top + glideEl.outerHeight());
          const diff = offsetTop - offsetBottom;
          const glideHeight = glideEl.outerHeight();

          position = glideHeight / 2 - arrowHeight / 2 - diff;
        }

        carousel.find(".arrow-container").css("top", position);
      };
      const getGap = () => {
        const windowWidth = $(window).outerWidth();

        if (windowWidth < 1024) {
          return (windowWidth - carousel.find(".outer").width()) / 2;
        }
        if (windowWidth >= 1024) {
          return carousel.css("paddingRight");
        }
      };

      const glide = new Glide(carousel.find(".glide")[0], {
        perView: 1,
        gap: getGap(),
        bound: true
      });

      glide.mount();
      setArrowPosition();

      glide.on("resize", () => {
        glide.update({ gap: getGap() });
        setArrowPosition();
      });

      glide.on("move.after", () => {
        const index = glide.index + 1;
        carousel.find(".carousel-index").text(index);
        setArrowPosition();
      });
    });
  }
});
